module.exports = __webpack_public_path__ + "img/password.a14e357f.svg";